import { routeLinks } from "constants/paths";
import {
  ButtonLink,
  ErrorHeading,
  ErrorMessage,
  PageNotFoundContainer,
} from "./Styled";

export const PageNotFound = () => {
  return (
    <PageNotFoundContainer>
      <ErrorHeading variant="h2">404 - Page Not Found</ErrorHeading>
      <ErrorMessage variant="body1">
        The page you are looking for could not be found.
      </ErrorMessage>
      <ButtonLink variant="contained" href={routeLinks.dashboardCommon}>
        Return to Homepage
      </ButtonLink>
    </PageNotFoundContainer>
  );
};
